import React from "react";

const WhyChooseUs = () => {
  const strengths = [
    {
      icon: "fa-globe",
      title: "Global Reach",
      delay: "0.1s",
      desc: "Extensive network connecting top talent with employers across the Gulf and beyond.",
    },
    {
      icon: "fa-users-cog",
      title: "Expert Screening",
      delay: "0.3s",
      desc: "Rigorous vetting process to ensure only the most qualified candidates are selected.",
    },
    {
      icon: "fa-file-invoice-dollar",
      title: "Visa Assistance",
      delay: "0.5s",
      desc: "Complete support with documentation and legalities for a hassle-free transition.",
    },
    {
      icon: "fa-handshake",
      title: "Trusted Ethics",
      delay: "0.7s",
      desc: "Operating with 100% transparency and professional integrity in every deal.",
    },
  ];

  return (
    <div className="container-xxl py-5">
      {/*
          STRICT OVERRIDE: This style block targets the template's hover
          behavior directly to prevent the white-out issue.
      */}
      <style>{`
        .service-item:hover h5,
        .service-item:hover p,
        .service-item:hover .text-dark,
        .service-item:hover .text-muted {
            color: inherit !important;
        }

        /* Specifically targeting the Global Reach card if it's acting up */
        .service-item {
            background-color: #fff !important;
        }
      `}</style>

      <div className="container">
        <div
          className="text-center mx-auto mb-5 wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "600px" }}
        >
          <h6 className="section-title bg-white text-center text-primary px-3">
            Why Choose Us
          </h6>
          <h1 className="display-6 mb-4">Our Core Strengths</h1>
          <p className="text-muted">
            We take pride in our ability to bridge the gap between world-class
            organizations and exceptional talent.
          </p>
        </div>

        <div className="row g-4">
          {strengths.map((item, index) => (
            <div
              className="col-lg-3 col-md-6 wow fadeInUp"
              key={index}
              data-wow-delay={item.delay}
            >
              <div
                className="service-item h-100 p-5 text-center shadow-sm"
                style={{
                  borderRadius: "20px",
                  transition: "all 0.4s ease",
                  position: "relative",
                  backgroundColor: "#ffffff",
                  border: "1px solid #eee",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.boxShadow =
                    "0 1rem 3rem rgba(0,0,0,.1)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 .125rem .25rem rgba(0,0,0,.075)";
                }}
              >
                <div
                  className="icon-box bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
                  style={{ width: "80px", height: "80px" }}
                >
                  <i className={`fa ${item.icon} fa-2x text-primary`} />
                </div>

                {/* Fixed colors using inline !important styles */}
                <h5
                  className="mb-3 fw-bold"
                  style={{ color: "#212529 !important" }}
                >
                  {item.title}
                </h5>
                <p
                  className="mb-0"
                  style={{
                    color: "#6c757d !important",
                    fontSize: "0.9rem",
                    lineHeight: "1.6",
                  }}
                >
                  {item.desc}
                </p>

                <div
                  className="position-absolute bottom-0 start-50 translate-middle-x bg-primary"
                  style={{
                    width: "40px",
                    height: "3px",
                    borderRadius: "10px 10px 0 0",
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
